import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-completed-screener-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="They did it! Your student(s) completed a Screener 👏"
      [preambles]="[{
        text: 'The student(s) below completed the WordFlight Screener today. The Screener reliably predicts '
          + 'performance on standardized reading measures — it tells you whether a student’s foundational skills are '
          + 'likely proficient, at some risk, or at high risk. Here’s what to do with the results.'
      }]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Go to Student Subscriptions"
      ctaRoute="/students/manage-subscriptions"
      closingText="Not sure where a student lands? Reach out — we’re happy to help you read the results."
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Date</th>
          <th class="th">Assessment</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td"><span class="date-display">{{ notification.data['displaydate'] }}</span></td>
            <td class="td"><span class="badge-green">Screener</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true,
})
export class CompletedScreenerNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Go to Enroll > Student Subscriptions',
      body: 'Use the checkbox next to each student’s name to enroll.'
    },
    {
      title: 'Use these guidelines to decide who to enroll',
      body: '<p><span style="color: #B91C1C; font-weight: bold;">Red (high risk)</span> or <span style="color: #F2AE43; font-weight: bold;">yellow (some risk)</span>: Strong candidate for WordFlight. </p>'
        + '<p><span style="color: #555555; font-weight: bold;">Score below 50 and/or no sound-letter correspondence</span>: Not yet ready for WordFlight.</p>'
        + '<p><span style="color: #0F54A6; font-weight: bold;">Borderline proficient (400–450 for grades 2–4, or 300–350 for grade 5+)</span>: May benefit — cross-reference your benchmark data to decide.</p>'
    }
  ];
}
